<div class="banking-tab">
  <div class="toolbar">
    <button mat-raised-button color="primary" (click)="startAdd()" *ngIf="!showForm">
      <mat-icon>add</mat-icon> Add bank account
    </button>
  </div>

  <div *ngIf="isLoading" class="loading"><mat-spinner diameter="32"></mat-spinner></div>
  <div *ngIf="!isLoading && loadError" class="error">{{ loadError }}</div>

  <!-- Add / edit form -->
  <div *ngIf="showForm" class="bank-form">
    <h4>{{ editingId ? 'Edit bank account' : 'Add bank account' }}</h4>

    <mat-form-field appearance="outline" class="full">
      <mat-label>Account holder name</mat-label>
      <input matInput [(ngModel)]="form.accountHolderName" maxlength="100">
    </mat-form-field>

    <mat-form-field appearance="outline" class="full">
      <mat-label>Bank name</mat-label>
      <input matInput [(ngModel)]="form.bankName" maxlength="100">
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="!editingId">
      <mat-label>Routing number</mat-label>
      <input matInput [(ngModel)]="form.routingNumber" maxlength="9" placeholder="9 digits">
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="!editingId">
      <mat-label>Account number</mat-label>
      <input matInput [(ngModel)]="form.accountNumber" maxlength="17"
             autocomplete="off" placeholder="Stored masked (last 4)">
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Account type</mat-label>
      <mat-select [(ngModel)]="form.accountType">
        <mat-option *ngFor="let t of accountTypes" [value]="t">{{ t }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline">
      <mat-label>Purpose</mat-label>
      <mat-select [(ngModel)]="form.purpose">
        <mat-option *ngFor="let p of purposes" [value]="p">{{ p }}</mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="editingId">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="form.status">
        <mat-option *ngFor="let s of statuses" [value]="s">{{ s }}</mat-option>
      </mat-select>
    </mat-form-field>

    <div *ngIf="saveError" class="error">{{ saveError }}</div>

    <div class="form-actions">
      <button mat-button (click)="cancel()">Cancel</button>
      <button mat-raised-button color="primary" (click)="save()">Save</button>
    </div>
  </div>

  <!-- List -->
  <div *ngIf="!isLoading && !loadError && bankAccounts.length === 0 && !showForm" class="empty">
    No bank accounts on file for this account.
  </div>

  <table mat-table [dataSource]="bankAccounts" class="bank-table"
         *ngIf="!isLoading && !loadError && bankAccounts.length > 0">

    <ng-container matColumnDef="bankName">
      <th mat-header-cell *matHeaderCellDef>Bank</th>
      <td mat-cell *matCellDef="let b">{{ b.bankName || '—' }}<div class="holder">{{ b.accountHolderName }}</div></td>
    </ng-container>

    <ng-container matColumnDef="accountNumberLast4">
      <th mat-header-cell *matHeaderCellDef>Account #</th>
      <td mat-cell *matCellDef="let b">••••{{ b.accountNumberLast4 }}</td>
    </ng-container>

    <ng-container matColumnDef="accountType">
      <th mat-header-cell *matHeaderCellDef>Type</th>
      <td mat-cell *matCellDef="let b">{{ b.accountType }}</td>
    </ng-container>

    <ng-container matColumnDef="purpose">
      <th mat-header-cell *matHeaderCellDef>Purpose</th>
      <td mat-cell *matCellDef="let b">{{ b.purpose }}</td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef>Status</th>
      <td mat-cell *matCellDef="let b">{{ b.status }}</td>
    </ng-container>

    <ng-container matColumnDef="default">
      <th mat-header-cell *matHeaderCellDef>Default</th>
      <td mat-cell *matCellDef="let b">
        <mat-chip *ngIf="b.isDefault" color="primary" selected>Default</mat-chip>
        <button *ngIf="!b.isDefault" mat-button (click)="setDefault(b)">Set default</button>
      </td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let b">
        <button mat-icon-button (click)="startEdit(b)" aria-label="Edit" title="Edit">
          <mat-icon>edit</mat-icon>
        </button>
        <button mat-icon-button color="warn" (click)="remove(b)" aria-label="Remove" title="Remove">
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
